import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../angular/models/account.model";
import {SupplyAccountType} from "../../types/supply-account.type";
import {DemandAccountType} from "../../types/demand-account.type";
import {AccountType} from "../../types/account.type";
import {AddressesService} from "../../../addresses/services/addresses-service.factory";
import {PhoneAndEmailFactoryService} from "../../../commons/services/phone-and-email-factory.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class AccountFormCtrl implements IController {

  account: AccountModel;
  demand: any;
  supply: any;
  isEdit: boolean;
  billingAccountMode: any;
  onChange: Function;
  onExistingBillingAccountChange: Function;

  private country: any;
  private loading: boolean;
  private isPrivateDemand: any;
  private accountTypesRef: any;
  private businessCategoriesRef: any;
  private customAddressEnabled: boolean;
  public billingAccountTypes: any = ["Manual", "PerTransaction", "PerTransactionInvoiceMonthly", "PerTransactionPerioidicInvoice", "DebitThreshold"];
  public billingAccountsRef: any;
  public billingAccount?: any;
  public supplyAccountTypes: typeof SupplyAccountType = SupplyAccountType;
  public tplProviders: string[];

  /* @ngInject */
  constructor(private businessCategories, private phoneAndEmailFactoryService: PhoneAndEmailFactoryService,
              private splitService: SplitService, private addressesService: AddressesService, private $billingAccounts, private $log) {
  }

  $onInit() {
    this.tplProviders = this.splitService.getSupportedThreePlProviders();
    this.billingAccountsRef = this.$billingAccounts();
    this.country = this.splitService.getCountryCode();
    this.loading = false;
    if (this.isEdit === true && !_.isUndefined(this.account.billingAccountId) && this.demand) {
      this.$billingAccounts(this.account.billingAccountId).$asyncValue()
        .then((billingAccount) => {
          this.billingAccount = billingAccount;
        })
        .catch((error) => {
          this.$log.error('Failed to get shipper accounts', error);
        });
    } else if (!this.isEdit && !this.billingAccountMode) {
      this.billingAccountMode = "New";
    }
    this.businessCategoriesRef = this.businessCategories;

    const supplyAccountTypesRef = [this.supplyAccountTypes.PrivateSupply, this.supplyAccountTypes.BusinessSupply];
    this.accountTypesRef = this.demand ? Object.values(DemandAccountType) : (this.supply ? supplyAccountTypesRef : Object.values(AccountType));

    this.isPrivateDemand = _.isEqual(this.account.type, 'PrivateDemand');
    this.customAddressEnabled = false;
  };


  onAddressChange(fullAddress) {
    if (_.isUndefined(this.account.address)) {
      _.set(this.account, 'address', {})
    }
    this.account.address = fullAddress;
  }

  onEmailChange(email) {
    this.account.billingAccount.billingContacts = [{
      email: email
    }]
  }

  onTimeZoneChange(zoneId) {
    this.account.billingAccount.zoneId = zoneId;
  }

  onPhoneChange(phoneNumber, form, fieldName) {
    this.account.phoneNumber = phoneNumber;
    this.phoneAndEmailFactoryService.phoneFormValidation(phoneNumber, this.country, form, fieldName);
  }

  onAdditionalPhoneChange(phoneNumber, form, fieldName) {
    if (!!phoneNumber) {
      this.account.additionalPhoneNumber = phoneNumber;
      this.phoneAndEmailFactoryService.phoneFormValidation(phoneNumber, this.country, form, fieldName);
    } else {
      this.account.additionalPhoneNumber = undefined;
      form[fieldName].$setValidity('valid', true);
    }

  }

  onAccountTypeChange(accountType) {
    this.isPrivateDemand = _.isEqual(accountType, 'PrivateDemand')
  }

  onToggleCustomAddress() {
    this.customAddressEnabled = !this.customAddressEnabled;
  }

  onOrderLocationSelect(location) {
    if (!this.account.address) {
      this.account.address = {}
    }
    this.account.address.location = this.addressesService.getAddressLocation(location.lat, location.lng);
  }

  onTagsChange(tags) {
    this.account.tags = tags;
  }
}

angular
  .module('bringoz.admin.accounts')
  .component('accountForm', {
    require: {
      form: '^form'
    },
    bindings: {
      account: '<',
      isEdit: '<?',
      demand: '<',
      supply: '<',
      billingAccountMode: '<',
      onChange: '&',
      onExistingBillingAccountChange: '&'
    },
    template: require('./account-form.html').default,
    controller: AccountFormCtrl
  });


